<script>
	export default {
		onLaunch: function() {
			console.log('1')
			uni.addInterceptor("reLaunch", {
				invoke(e) {
					// console.log("back")
					// 因为刷新后进行后退会调用这个路径，所以需要劫持然后调用back方法。
					if (e.url == "/") {
						history.back();
						return false;
					}
				},
			});
		},
		onShow: function() {},
		onHide: function() {}
	};
</script>

<style lang="scss">
	/*每个页面公共css */
	@import '@/uni_modules/uv-ui-tools/index.scss';
	@import '@/static/index.css';

	.empty {
		display: flex;
		justify-content: center;
		padding: 120rpx 0 20rpx 0;

		.image {
			width: 300rpx;
			height: 300rpx;
			display: block;
		}
	}

	.beian {
		width: 100%;
		padding: 60rpx 30rpx 20rpx;
		color: #000;
		font-size: 30rpx;
		text-align: center;
	}
</style>